/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["hr[_ngcontent-%COMP%]{margin-top:0!important;margin-bottom:0!important}p[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0}.mat-card[_ngcontent-%COMP%]{padding:0}\n/*# sourceMappingURL=demand-trend-analysis.component.css.map*/"];
export { styles as styles };
